<template>
  <div id="app">
    <hy-layout >
      <router-view />
    </hy-layout>
  </div>
</template>

<script>
import HyLayout from './components/global/hy-layout'
import {chkLogin, chkVersion} from './service/util'

export default {
  name: 'App',
  components: {HyLayout},
  created () {
    console.log('App Created')
    chkVersion().then(res => {
      if (res.code === 201) {
        this.$confirm(res.data.message, res.data.version, {
          lockScroll: true,
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          confirmButtonText: '更新'
        }).then(r => {
          window.location.reload(-1)
        })
      }
    })
    chkLogin().then(res => {
      console.log(res)
    })
  }
}
</script>

<style>
body, html {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,SimSun,sans-serif;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: transparent;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100%;
  text-align: center;
  background-color: #e8ecf3;
  min-width: 1180px;
}
#nprogress .bar {
  background: #3264FF !important;
}
.w1180{
  display: inline-block;
  width: 98%;
  max-width: 1180px;
  height: 100%;
  margin: 0 auto;
  text-align: left;
}
.noborder .el-input__inner{
  border: 0 !important;
}
.el-carousel__arrow{
  background-color: rgba(31,45,61,.61);
}
</style>



// WEBPACK FOOTER //
// src/App.vue